import { DateTime as s, Interval as c } from "luxon";
function h(t) {
  const n = s.fromISO(t).weekday;
  return n !== 6 && n !== 7;
}
function u(t, n) {
  return n.some((r) => "start" in r && "end" in r ? c.fromDateTimes(
    // Since we want to start date to be inclusive, we are comparing against
    // the start of the day of the start date.
    s.fromISO(r.start).startOf("day"),
    // Since we want to end date to be exclusive, we are comparing against
    // the start of the day of the end date.
    s.fromISO(r.end).startOf("day")
  ).contains(s.fromISO(t)) : !1);
}
function I(t) {
  const n = t && t.at(0), o = t && t.at(-1), r = n && "end" in n && !("start" in n), f = o && "start" in o && !("end" in o);
  return {
    // let's make sure that we grab all of the items just in case
    min: r ? n.end : void 0,
    // Since Ionic defined `max` as exclusive, whereas we defined as inclusive,
    // we must negate a day.
    max: f ? s.fromISO(o.start).minus({
      day: 1
    }).toISODate() ?? void 0 : void 0,
    // covers third and fourth cases in union
    disabledDateRanges: t == null ? void 0 : t.filter((i) => {
      var m, e;
      return "start" in i && ((m = i.start) == null ? void 0 : m.length) > 0 && "end" in i && ((e = i.end) == null ? void 0 : e.length) > 0;
    })
  };
}
export {
  h as isWeekday,
  u as isWithinDateRange,
  I as transformDateRanges
};
